import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // Adiciona useNavigate para redirecionamento
import CircularProgress from "@mui/material/CircularProgress";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { FormResource } from "../components/FormResource";
import { IResourceType } from "../../../@types/resource.type";
import vectorIcon from "./../../../assets/_VectorIcon_.svg";
import styles from "./styles.module.scss";
import { SkillsResource } from "../components/SkillsResource";
import { HistoryResource } from "../components/HistoryResource";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

interface ResourceProps {
  pageType: "create" | "update";
  resourceData?: IResourceType;
  setOpenModalAvailability: React.Dispatch<React.SetStateAction<boolean>>;
  isSyncActive?: boolean;
}

export const Resource: React.FC<ResourceProps> = ({
  pageType,
  resourceData,
  setOpenModalAvailability,
  isSyncActive = false,
}) => {
  const navigate = useNavigate();
  const [value, setValue] = React.useState(0);

  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function CustomTabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && <Box sx={{ p: 0 }}>{children}</Box>}
      </div>
    );
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    };
  }
  const [loading, setLoading] = useState<boolean>(false);

  return (
    <>
      {loading ? (
        <CircularProgress
          size={100}
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
      ) : (
        <div className={styles.updateResource}>
          <div className={styles.back}>
            <Button
              className={styles.button}
              onClick={() => navigate("/resources")}
            >
              {vectorIcon && <img src={vectorIcon} />}
              Voltar a tela anterior
            </Button>
          </div>
          <div className={styles.title}>
            <h1>
              {pageType === "update"
                ? `${resourceData?.firstname} ${resourceData?.lastname}`
                : "Novo Colaborador"}
            </h1>
          </div>
          <div>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
                classes={{
                  indicator: styles["MuiTabs-indicator"], // Usando colchetes para o nome da classe
                }}
              >
                <Tab
                  label="Dados do Colaborador"
                  {...a11yProps(0)}
                  className={styles.tab}
                />
                <Tab
                  label="Skills do Colaborador"
                  {...a11yProps(1)}
                  className={styles.tab}
                />
                 <Tab
                  label="Históricos do Colaborador"
                  {...a11yProps(2)}
                  className={styles.tab}
                />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <FormResource
                pageType={pageType}
                resourceData={resourceData}
                setOpenModalAvailability={setOpenModalAvailability}
                isSyncActive={isSyncActive}
              />

              {/* <h3>Custos </h3>
            <CostResource/> */}
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <SkillsResource resourceId={resourceData && resourceData.id ? resourceData.id : ""} />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <HistoryResource resourceId={resourceData && resourceData.id ? resourceData.id : ""} />
            </CustomTabPanel>
          </div>
        </div>
      )}
    </>
  );
};
